module.exports = __webpack_public_path__ + "img/chargingpoint-suggestion.3da17495.svg";